import Sales from '@/views/sales'
import Simulation from '@/views/sales/simulation'
import Procedures from '@/views/sales/procedures'
import SalesDeals from '@/views/sales/deals'
import SalesDealsList from '@/views/sales/deals/list/index.vue'
import SalesDealsFinancialAnalysis from '@/views/sales/deals/financial-analysis'
import Payments from '@/views/payments'
import Invoice from '@/views/invoice'
import SalesDealsFunnel from '@/views/sales/deals/kanban'
import SalesProposal from '@/views/sales/proposal'
import SalesProposalList from '@/views/sales/proposal/list'
import SalesReservations from '@/views/sales/reservations'
import SalesReservationsList from '@/views/sales/reservations/list'
import SalesTransferReservations from '@/views/sales/reservations/transfer-reservations'
import Integrations from '@/views/sales/settings'
import ContractGeneration from '@/views/sales/settings/contract-generation'
import { storage } from '@/services/storage'

var routes = [
    {
        path: '/vendas',
        name: 'sales',
        component: Sales,
        meta: {
            title: (storage.get('client_name') || 'Facilita') + ' - Vendas',
            protect: true,
        },
        children: [
            {
                path: 'cobrancas',
                name: 'cobrancas',
                component: Payments,
                meta: {
                    title: (storage.get('client_name') || 'Facilita') + ' - Cobranças',
                    protect: true,
                },
            },
            {
                path: 'cobranca-gerada',
                name: 'cobranca.gerada',
                component: Invoice,
                meta: {
                    title: (storage.get('client_name') || 'Facilita') + ' - Cobrança Gerada',
                    protect: true,
                },
            },
            {
                path: 'negocios',
                name: 'sales.deals',
                component: SalesDeals,
                meta: {
                    title: (storage.get('client_name') || 'Facilita') + ' - Negócios',
                    protect: true,
                },
                children: [
                    {
                        path: 'lista',
                        name: 'sales.deals.list',
                        component: SalesDealsList,
                        props: true,
                        meta: {
                            title: (storage.get('client_name') || 'Facilita') + ' - Lista de Clientes',
                            protect: true,
                        },
                    },
                    {
                        path: 'funil/:funnel_id?',
                        name: 'sales.deals.funnel',
                        component: SalesDealsFunnel,
                        props: true,
                        meta: {
                            title: (storage.get('client_name') || 'Facilita') + ' - Funil de Clientes',
                            protect: true,
                        },
                        children: [
                            {
                                path: 'status/:id/:title',
                                name: 'sales.deals.funnel.status',
                                component: SalesDealsFunnel,
                                props: true,
                                meta: {
                                    title: (storage.get('client_name') || 'Facilita') + ' - Funil de Clientes',
                                    protect: true,
                                },
                            },
                            {
                                path: 'pre/:id',
                                name: 'sales.deals.funnel.pre',
                                component: SalesDealsFunnel,
                                props: true,
                                meta: {
                                    title: (storage.get('client_name') || 'Facilita') + ' - Funil de Clientes',
                                    protect: true,
                                },
                            }

                        ]
                    },
                    {
                        path: 'analise-financeira-vertical/:id',
                        name: 'sales.deals.financial-analysis',
                        component: SalesDealsFinancialAnalysis,
                        props: true,
                        meta: {
                            title: (storage.get('client_name') || 'Facilita') + ' - Análise Financeira Vertical',
                            protect: true,
                        },
                    }
                ]
            },
            {
                path: 'propostas',
                name: 'sales.proposal',
                component: SalesProposal,
                meta: {
                    title: (storage.get('client_name') || 'Facilita') + ' - Propostas',
                    protect: true,
                },
                children: [
                    {
                        path: 'lista',
                        name: 'sales.proposal.list',
                        component: SalesProposalList,
                        props: true,
                        meta: {
                            title: (storage.get('client_name') || 'Facilita') + ' - Lista de Propostas',
                            protect: true,
                        },
                    },
                ]
            },
            {
                path: 'reservas',
                name: 'sales.reservations',
                component: SalesReservations,
                meta: {
                    title: (storage.get('client_name') || 'Facilita') + ' - Reservas',
                    protect: true,
                },
                children: [
                    {
                        path: 'lista',
                        name: 'sales.reservations.list',
                        component: SalesReservationsList,
                        props: true,
                        meta: {
                            title: (storage.get('client_name') || 'Facilita') + ' - Lista de Reservas',
                            protect: true,
                        },
                    },
                    {
                        path: 'transferencia-de-reservas',
                        name: 'transfer.reservations',
                        component: SalesTransferReservations,
                        props: true,
                        meta: {
                            title: (storage.get('client_name') || 'Facilita') + ' - Lista de Reservas',
                            protect: true,
                        },
                    },
                ]
            },
            {
                path: 'simulacao/:id?',
                name: 'sales.simulation',
                component: Simulation,
                props: true,
                meta: {
                    title: (storage.get('client_name') || 'Facilita') + ' - Simulação',
                    protect: true,
                    // rules: {
                    //     groups: [
                    //         'admin',
                    //         'collaborator',
                    //         'broker',
                    //         'manager',
                    //         'supervisor'
                    //     ],
                    //     redirect: '/',
                    // }
                }
            },
            {
                path: 'procedimentos/:id/:guide',
                name: 'sales.procedures',
                component: Procedures,
                props: true,
                meta: {
                    title: (storage.get('client_name') || 'Facilita') + ' - Procedimentos',
                    protect: true,
                    // rules: {
                    //     groups: [
                    //         'admin',
                    //         'collaborator',
                    //         'broker',
                    //         'manager',
                    //         'supervisor'
                    //     ],
                    //     redirect: '/',
                    // }
                }
            },
            {
                path: 'configuracao',
                name: 'sales.integrations',
                component: Integrations,
                meta: {
                    title: (storage.get('client_name') || 'Facilita') + ' - Configuração',
                    protect: true,
                    rules: {
                        groups: [
                            'admin',
                            'collaborator',
                        ],
                        redirect: {name: 'errors.not.unauthorized'}
                    }
                },
                children: [
                    {
                        path: 'geracao-de-contratos',
                        name: 'sales.integrations.contractGeneration',
                        component: ContractGeneration,
                        meta: {
                            title: (storage.get('client_name') || 'Facilita') + ' - Gerador de Documentos e Contratos',
                            protect: true,
                            rules: {
                                groups: [
                                    'admin',
                                    'collaborator',
                                    'dinamic'
                                ],
                                redirect: {name: 'errors.not.unauthorized'}
                            }
                        },
                    },
                ]
            }
        ]
    }
]

export { routes }